import React, { Component } from 'react';
import { Row } from 'react-bootstrap';
import PageNotFound from './img/404.svg';
import './css/style.scss';

class NotFound extends Component {
  state = {};
  render() {
    return (
      <Row className='d-flex m-0 notfound'>
        <img src={PageNotFound} alt='404' className='m-3' />
        <h1>Page Not Found</h1>
      </Row>
    );
  }
}

export default NotFound;
